import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ManifestoEdicao } from '@/features/mdfe/page/edicao/ManifestoEdicao';
import { StringToIdpkSchema } from '@/std/schema';

const RouteManifestoCargaParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteManifestoCargaParams = z.infer<typeof RouteManifestoCargaParamsSchema>;

export const Route = createFileRoute('/a/manifesto-carga/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteManifestoCargaParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <ManifestoEdicao {...params} />;
}
